import { Lightbulb, Palette, FileCheck2, Sparkles } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    icon: Lightbulb,
    title: "Share your idea.",
    body: "Send a sketch, a screenshot, a logo, or just a rambling description — whatever you have. Rough ideas are our favourite kind.",
  },
  {
    icon: Palette,
    title: "Discuss the design, size, and colours.",
    body: "We redraw your idea into a tufting-ready design, suggest sizes and yarn colours, and refine it with you on WhatsApp until it feels right.",
  },
  {
    icon: FileCheck2,
    title: "Confirm your quote and design.",
    body: "You get a clear quote based on your final design. Approve it, and your rug joins the frame.",
  },
  {
    icon: Sparkles,
    title: "Your rug is handcrafted.",
    body: "Punched, carved and finished by hand — then it's ready to make your space yours.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 sm:py-24" data-testid="how-it-works">
      <div className="max-w-6xl mx-auto px-5 sm:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs sm:text-sm uppercase tracking-[0.22em] text-burgundy font-medium">
              <span className="inline-block h-2 w-2 rounded-full bg-brass" aria-hidden="true" />
              How it works
            </p>
            <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-forest">
              Made around your imagination.
            </h2>
          </div>
        </Reveal>

        <div className="relative mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
          <div
            aria-hidden="true"
            className="hidden lg:block absolute top-9 left-[12%] right-[12%] border-t-2 border-dashed border-brass/60"
          />
          {STEPS.map((s, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="relative" data-testid={`how-it-works-step-${i + 1}`}>
                <div className="relative z-10 inline-flex h-[4.5rem] w-[4.5rem] items-center justify-center rounded-full bg-forest text-ivory shadow-tuft">
                  <s.icon className="h-7 w-7" strokeWidth={1.6} />
                  <span className="absolute -top-1 -right-1 inline-flex h-7 w-7 items-center justify-center rounded-full bg-brass text-forest text-xs font-semibold">
                    {i + 1}
                  </span>
                </div>
                <h3 className="mt-5 font-serif text-xl text-forest leading-snug">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-charcoal/70">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
